import {styled, Typography} from '@mui/material'
import {Box} from '@mui/system'
import {dashboardStatuses} from 'constants/dashboard'
import {useI18n} from 'store/Store'
import SimpleTable from '../Dashboard/SimpleTable'
import {StyledTab, StyledTabs} from './styles'
import TabPanel from './TabPanel'
import {useNavigate} from 'react-router-dom'

const tabProps = (index) => {
    return {
        id: `tab-${index}`,
        'aria-controls': `tabpanel-${index}`,
    }
}

const RequestsTabs = ({tabsTitle, data, selectedStatus, setSelectedStatus}) => {
    const {i18n} = useI18n()
    const navigate = useNavigate()

    const value = dashboardStatuses.indexOf(selectedStatus)

    const handleChange = (event, newValue) => {
        setSelectedStatus(dashboardStatuses[newValue])
    }

    return (
        <Container>
            {tabsTitle && (
                <Typography align="center" fontWeight={'bold'}>
                    {tabsTitle}
                </Typography>
            )}

            <StyledTabs value={value} onChange={handleChange} aria-label="tabs">
                {dashboardStatuses.map((status, index) => (
                    <StyledTab
                        label={i18n.t(`dashboard.tableStatuses.${status}`, {
                            count: data?.[status]?.length || 0,
                        })}
                        {...tabProps(index)}
                    />
                ))}
            </StyledTabs>

            {dashboardStatuses.map((status, index) => (
                <TabPanel value={value} index={index}>
                    <SimpleTable
                        itemName="request"
                        data={data?.[status]}
                        onClickRow={(client) =>
                            navigate(`/client/${client.id}`)
                        }
                    />
                </TabPanel>
            ))}
        </Container>
    )
}

export default RequestsTabs

const Container = styled(Box)`
    display: flex;
    flex-direction: column;
    /* justify-content: space-between; */
    width: 100%;
    height: 100%;
`
